<template>
  <div>
    <RF-Dialog
      :cpntStatus='statusGeral'
      :cpntLargura='"900px"'
      :cpntTitulo='"Gerar Etiqueta"'

      :cpntOnFecharDialog='comEtiqFechar'>
      <template slot='conteudo'>
        <div class="com-etiq">
          <RF-Tabela :data-time='time' v-if="Object.keys(tabelaQtde).length >= 1"
            :cpntTime='time'

            :cpntId='tabelaQtde.id'
            :cpntStatus='tabelaQtde.status'
            :cpntMper='tabelaQtde.mPer'
            :cpntColuna='tabelaQtde.coluna'
            :cpntFraseTop='tabelaQtde.fraseTop'
            :cpntLinha='tabelaQtde.linha'
            :cpntButtonsAcoes='tabelaQtde.acoes.buttons'
            :cpntEditar='tabelaQtde.cpntEditar'
            :cpntButtonImprimir='tabelaQtde.buttonImprimir'
            :cpntButtonAtualizar='tabelaQtde.buttonAtualizar'
            :cpntPagina='tabelaQtde.pagina'
            :cpntCountAll='tabelaQtde.countAll'
            :ref='tabelaQtde.id'

            :cpntOnRefreshTabela="comEtiqIniciar"
          ></RF-Tabela>

          <div v-if="Object.keys(iniciarEm).length >= 1" style="text-align: center;">
              Iniciar na 
              <RF-Select2 style="width: 50px; margin-bottom: 0px; vertical-align: middle;"
                :data-time="time"

                :cpntStatus='iniciarEm.status'
                :cpntId='iniciarEm.id + "_ger_impressao"'
                :cpntClassDivField='iniciarEm.classDivField'
                :cpntNome='iniciarEm.nome'
                :cpntValue='iniciarEm.value'
                :cpntOptions='iniciarEm.options'
                :cpntKeyValue='iniciarEm.keyValue'
                :cpntKeyMostra='iniciarEm.keyMostra'
                :cpntAutoComplete='iniciarEm.autocomplete'
                :cpntDisabled='iniciarEm.disabled'
                :cpntMostrar='iniciarEm.mostrar'
                :cpntMensagem='iniciarEm.mensagem'
                :cpntOptionInicialNome='iniciarEm.optionInicialNome'
                :cpntOptionInicialValue='iniciarEm.optionInicialValue'
                :cpntMensagemTipo='iniciarEm.mensagemTipo'
                :cpntAddOption='iniciarEm.addOption'
                :cpntMultiple='iniciarEm.multiple'
                :cpntExplica='iniciarEm.explica'
                :cpntClassSelect='iniciarEm.classSelect2'
                :cpntTabIndex='iniciarEm.tabIndex'

                :cpntOnKeyPressEnter='iniciarEm.onKeyPressEnter'
                :cpntOnChange='iniciarEm.onChange'
                :cpntOnBlur='iniciarEm.onBlur'
                :ref='iniciarEm.tipo'
              ></RF-Select2>
              coluna
            </div>

          <div v-if="Object.keys(buttons).length >= 1" class="com-etiq-gerar">
            <RF-Button v-for="(button, index) in buttons" :key="'buttons-' + index"
              :cpntId='button.id'
              :cpntStatus='button.status' 
              :cpntTexto='button.texto' 
              :cpntClass='button.class'
              :cpntDisabled='button.disabled'
              :cpntMostrar='button.mostrar'

              @onClickButton='button.onClick'
            ></RF-Button>
          </div>

          <div v-if="mostrarConfig === true && Object.keys(tabelaConfig).length >= 1">
            <RF-Tabela :data-time='time' v-for="(tabela, index) in tabelaConfig" :key="index"
              :cpntTime='time'

              :cpntId='tabela.id'
              :cpntStatus='tabela.status'
              :cpntMper='tabela.mPer'
              :cpntColuna='tabela.coluna'
              :cpntFraseTop='tabela.fraseTop'
              :cpntLinha='tabela.linha'
              :cpntButtonsAcoes='tabela.acoes.buttons'
              :cpntEditar='tabela.cpntEditar'
              :cpntButtonImprimir='tabela.buttonImprimir'
              :cpntButtonAtualizar='tabela.buttonAtualizar'
              :cpntPagina='tabela.pagina'
              :cpntCountAll='tabela.countAll'
              :ref='tabela.id'

              :cpntOnRefreshTabela="comEtiqIniciar"
            ></RF-Tabela>

            <div v-if="Object.keys(buttonsConfig).length >= 1">
              <RF-Button v-for="(button, index) in buttonsConfig" :key="'buttonsConfig-' + index"
                :cpntId='button.id'
                :cpntStatus='button.status' 
                :cpntTexto='button.texto' 
                :cpntClass='button.class'
                :cpntDisabled='button.disabled'
                :cpntMostrar='button.mostrar'

                @onClickButton='button.onClick'
              ></RF-Button>
            </div>
          </div>
        </div>
        
      </template>
    </RF-Dialog>

    <RF-Dialog v-if="Object.keys(config).length >= 1 && gerarImpressao !== null"
      :cpntStatus='statusGeral'
      :cpntLargura='"600px"'
      :cpntStatusImprimir='buttonImprimir.statusImprimir'

      :cpntOnFecharDialog='comEtiqGerarImpressao'>
      <template slot='titulo'>
        <RF-Button
          :cpntId='buttonImprimir.id'
          :cpntStatus='buttonImprimir.status' 
          :cpntTexto='buttonImprimir.texto' 
          :cpntClass='buttonImprimir.class'
          :cpntDisabled='buttonImprimir.disabled'
          :cpntMostrar='buttonImprimir.mostrar'

          @onClickButton='buttonImprimir.onClick'
        ></RF-Button>
      </template>

      <template slot='conteudo'>
        <div>
          <div id="rf-dialog-etiq-imprmir" class="etiq-imprimir" style="width: 100%; padding: 0px; margin: 0px;">
            <table :style="'border-spacing: 0px; border-collapse: separate;'">
              <tr v-for="(linha, indexL) in gerarImpressao" :key="'etiqueta-linha-' + indexL">
                <td v-for="(coluna, indexC) in linha" :key="'etiqueta-coluna-' + indexC" style="padding: 0px;">
                  <div v-if="coluna === 'vazio'" :style="'width: ' + config.cfg_tam_celula + 'px;' + (config.cfg_borda_etiq === '1' ? 'border: 1px dotted;' : '') + ' margin: ' + config.cfg_f_mar_top + 'px ' + config.cfg_f_mar_right + 'px ' + config.cfg_f_mar_button + 'px; padding: ' + config.cfg_d_mar_top + 'px ' + config.cfg_d_mar_right + 'px ' + config.cfg_d_mar_button + 'px ' + config.cfg_d_mar_left + 'px ' + ';'">
                    &nbsp;
                  </div>
                  <div v-else :style="'width: ' + config.cfg_tam_celula + 'px;' + (config.cfg_borda_etiq === '1' ? 'border: 1px dotted;' : '') + ' margin: ' + config.cfg_f_mar_top + 'px ' + config.cfg_f_mar_right + 'px ' + config.cfg_f_mar_button + 'px; padding: ' + config.cfg_d_mar_top + 'px ' + config.cfg_d_mar_right + 'px ' + config.cfg_d_mar_button + 'px ' + config.cfg_d_mar_left + 'px ' + ';'">
                    <table :style="'width: ' + (Number(config.cfg_tam_celula) + 5) + 'px; border-spacing: 0px; border-collapse: separate; ' + fonte">
                      <tr v-if="[ '9000', '2526' ].indexOf($store.state.token.clu) !== -1">
                        <td :style="'width: ' + config.cfg_tam_celula + 'px; text-align: center; padding-left: 5px; padding-right: 5px; font-size: ' + config.cfg_tam_font_nome + 'px;' + fonte" colspan="4">
                          <!-- <img :src="$store.state.logotipo" :style="'max-width: 100%; max-height: 90px;'" /> -->
                          <!-- <img src="https://s3-sa-east-1.amazonaws.com/arq.rotinafacil.com/img_cli/iavtbiqxbwktfvclqesztbkvyweizlgodmnusisudgoxhfmltl.png?v=1" :style="'max-width: 100%; max-height: 50px;'" /> -->
                          <img src="./FerreiraFilho.png" :style="'max-width: 100%; max-height: 50px;'" />
                          <!-- <span :style="'font-size: ' + (Number(config.cfg_tam_font_nome) - 2) + 'px;'">
                            Av. Joao Gualberto, 1644
                          </span> -->
                        </td>
                      </tr>
                      <tr>
                        <td :style="'width: ' + config.cfg_tam_celula + 'px; text-align: center; padding-left: 5px; padding-right: 5px; font-size: ' + (Number(config.cfg_tam_font_nome) + 2) + 'px;' + fonte" colspan="4" v-html="coluna.id_cat_nome"></td>
                      </tr>
                      <tr>
                        <td :style="'width: 100%; text-align: left; padding-left: 5px; font-size: ' + config.cfg_tam_font_nome + 'px;' + fonte" colspan="4" v-html="coluna.obs"></td>
                      </tr>
                      <tr>
                        <td :style="'width: 33.33%; text-align: left; padding-left: 5px; font-size: ' + config.cfg_tam_font_nome + 'px;' + fonte" colspan="1" v-html="coluna.id_cat"></td>
                        <td :style="'width: 83.33%; text-align: right; padding-right: 5px; font-size: ' + config.cfg_tam_font_nome + 'px;' + fonte" colspan="3">
                          <span v-html="coluna.custo"></span>
                          <span v-html="coluna.data"></span>
                        </td>
                      </tr>
                      <tr v-if="[ '9000', '2526' ].indexOf($store.state.token.clu) !== -1">
                        <td :style="'width: ' + config.cfg_tam_celula + 'px; text-align: center; padding-left: 5px; padding-right: 5px; font-size: ' + (Number(config.cfg_tam_font_nome) + 2) + 'px;' + fonte" colspan="4">
                          <div :style="'position: relative; margin-bottom: -2px; text-align: center; position: relative; z-index: 99999; font-size: ' + config.cfg_tam_font_cod + 'px; letter-spacing: ' + config.cfg_tam_esp_letra + 'px;' + fonte" v-html="coluna.cod_barra"></div>
                          <div style="height: 1px; clear: both; position: block;">&nbsp;</div>
                        </td>
                      </tr>
                      <tr>
                        <td :style="'vertical-align: bottom; text-align: center; font-size: ' + config.cfg_tam_font_nome + 'px;' + fonte" colspan="4">
                          <svg class="barcode" v-if="coluna.cod_barra !== ''" style="text-align: center;"
                            jsbarcode-format="CODE128"
                            :jsbarcode-value="coluna.cod_barra"
                            jsbarcode-margin="0"
                            jsbarcode-textmargin="0"
                            jsbarcode-textPosition="top"
                            :jsbarcode-height="Number(config.cfg_tam_cod_barra) + (config.cfg_tam_cod_barra * '0.80')"
                            :jsbarcode-fontSize="config.cfg_tam_font_cod"

                            :ref="'svg'"
                          ></svg>
                          <div v-else :style="'height: ' + (Number(config.cfg_tam_cod_barra) + 40) + 'px;' + fonte"></div>
                          <div :style="'position: relative; margin-top: -8px; text-align: center; position: relative; z-index: 99999; font-size: ' + config.cfg_tam_font_cod + 'px; letter-spacing: ' + config.cfg_tam_esp_letra + 'px;' + fonte" v-html="coluna.cod_barra"></div>
                          <div style="height: 1px; clear: both; position: block;">&nbsp;</div>
                        </td>
                      </tr>
                      <tr v-if="[ '9000', '2526' ].indexOf($store.state.token.clu) !== -1">
                        <td :style="'width: ' + config.cfg_tam_celula + 'px; text-align: center; padding-left: 5px; padding-right: 5px; font-size: ' + (Number(config.cfg_tam_font_nome) + 2) + 'px;' + fonte" colspan="4" v-html="coluna.id_cat_nome"></td>
                      </tr>
                      <!-- <tr>
                        <td :style="'width: 50%; text-align: left; padding-left: 5px; font-size: ' + (config.cfg_tam_font_nome - 2) + 'px;' + fonte" colspan="2" v-html="''"></td>
                        <td :style="'width: 50%; text-align: right; padding-right: 5px; font-size: ' + (config.cfg_tam_font_nome - 2) + 'px;' + fonte" colspan="2" >
                          <span v-html="coluna.custo"></span>
                          <span v-html="coluna.data"></span>
                        </td>
                      </tr>
                      <tr>
                        <td :style="'width: 83.33%; text-align: left; padding-left: 5px; font-size: ' + (config.cfg_tam_font_nome - 2) + 'px;' + fonte" colspan="3" v-html="coluna.obs"></td>
                        <td :style="'width: 33.33%; text-align: right; padding-right: 5px; font-size: ' + (config.cfg_tam_font_nome - 2) + 'px;' + fonte" colspan="1" v-html="coluna.id_cat"></td>
                      </tr> -->
                      <tr>
                        <td :style="'width: 100%; text-align: center; padding-left: 5px; padding-right: 5px; font-size: ' + config.cfg_tam_font_valor + 'px;' + fonte" colspan="4" v-html="'R$ ' + coluna._valor_ven"></td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
  .com-etiq-gerar {
    text-align: center;
    border: none !important;
  }
  .com-etiq-config-button > svg {
    cursor: pointer;
    font-size: var(--font-base-soma-19);
    color: #6f6f6f;
  }
  .com-etiq-config-button > div {
    width: 120px;
    min-width: 120px;
    display: inline-block;
    margin-right: 5px;
    font-size: var(--font-base-soma-16);
  }
    .com-etiq-config-button > div > svg {
      display: inline-block;
    }
    .com-etiq-config-button ~ div > div {
      text-align: center
    }
</style>

<style>
  table > thead > tr > th.tab-com-etiq-qtde-th-rf-qtde > button {
    margin-left: 5px;
  }
  .etiq-imprimir > table > tr > td > div > table > tr > td > svg.barcode > g > text {
    display: none !important;
  }
  .com-etiq > div:not(:first-child),
  .com-etiq > div > div:not(:first-child) {
    margin: 15px 0px;
  }
  .com-etiq > div > table > thead > tr > th > span .com-etiq-qtde-titulo,
  .com-etiq > div > div > table > thead > tr > th > span .com-etiq-qtde-titulo {
    text-align: center;
    font-size: var(--font-base-soma-14);
  }
  .com-etiq > div > table > tbody > tr > td,
  .com-etiq > div > div > table > tbody > tr > td {
    padding: 6px 0px !important;
  }
  .com-etiq > div > table > tbody > tr > td > div > input,
  .com-etiq > div > div> table > tbody > tr > td > div > input {
    border: 1px solid #ccc !important;
    border-radius: 5px !important;
    padding: 6px 5px !important;
    text-align: center;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },

      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        config: {},
        buttons: {},
        compraDados: {},
        compraItens: [],
        tabelaQtde: {},
        tabelaConfig: {},
        buttonsConfig: {},
        mostrarConfig: false,
        gerarImpressao: null,
        buttonImprimir: {},
        iniciarEm: {},
        custoCryto: { '1': 'R', '2': 'U', '3': 'S', '4': 'T', '5': 'I', '6': 'D', '7': 'E', '8': 'B', '9': 'A', '0': 'O' },
        fonte: ' font-family: Calibri;  font-style: normal;'
      }
    },
    mounted: function () {
      this.comEtiqIniciar()
    },
    methods: {
      comEtiqIniciar: function () {
        // RESETA TODOS OS CAMPOS
        this.time = ''
        this.statusGeral = ''
        this.config = {}
        this.buttons = {}
        this.compraDados = {}
        this.compraItens = []
        this.tabelaQtde = {}
        this.tabelaConfig = {}
        this.buttonsConfig = {}
        this.mostrarConfig = false
        this.gerarImpressao = null
        this.buttonImprimir = {}

        // SETA O STATUS PARA TELA
        this.comEtiqSetarStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA BUSCAR AS CONFIGURAÇÕES
        this.comEtiqBucarConfiguracoes(this.comEtiqBucarCompra)
      },
      comEtiqBucarConfiguracoes: function (callback = null) {
        var self = this

        self.$store.state.comunicaAPI('/produto/config/get/', 'GET', 'cb', function (apiSuccess) {
          // SETA OS DADOS RECEBIDOS
          self.config = apiSuccess.data[0]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA FUNÇÃO PARA BUSCAR OS DADOS DA COMPRA
          if (callback !== null) {
            callback()
          }
        }, self.comEtiqSetarStatusGeral)
      },
      comEtiqBucarCompra: function () {
        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // INICIA A QUERYGET QUE SERÁ REALIZADA
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: chaveD, o: '=', v: this.cpntDemandaId } ] }

        // INICIA A VARIAVEL QUE VAI RECEBER A ROTA QUE DEVE CHAMAR
        var router = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            router = '/venda/get'
            break

          case 'dev_cliente':
            router = '/demanda/dem-dev-cliente/get'
            break

          case 'compra':
            router = '/demanda/dem-compra/get'
            break
        }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
          // SETA OS DADOS RECEBIDOS
          this.compraDados = retorno.data[0]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA FUNÇÃO PARA BUSCAR OS ITENS DA COMPRA
          this.comEtiqBucarItensCompra()
        }, this.comEtiqSetarStatusGeral)

        // var self = this

        // // INICIA A BUSCA NA TELA DE COMPRA
        // var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'cod_compra', o: '=', v: self.$store.state.gerarEtiqCompra } }

        // self.$store.state.comunicaAPI('/compra/get/', 'GET', queryGet, function (apiSuccess) {
        //   // SETA OS DADOS RECEBIDOS
        //   self.compraDados = apiSuccess.data[0]

        //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   self.time = new Date().getTime()

        //   // CHAMA FUNÇÃO PARA BUSCAR OS ITENS DA COMPRA
        //   self.comEtiqBucarItensCompra()
        // }, self.comEtiqSetarStatusGeral)
      },
      comEtiqBucarItensCompra: function () {
        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // INICIA A QUERYGET QUE SERÁ REALIZADA
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: chaveD, o: '=', v: this.cpntDemandaId } ] }

        // INICIA A VARIAVEL QUE VAI RECEBER A ROTA QUE DEVE CHAMAR
        var router = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            router = '/venda/produto/get'
            break

          case 'dev_cliente':
            router = '/demanda/dem-dev-cliente/dem-produto/get'
            break

          case 'compra':
            router = '/demanda/dem-compra/dem-produto/get'
            break
        }

        // SETA OS CAMPOS QUE DEVE RETORNAR
        queryGet.field = {
          id: null,
          id_pro: { j: {
            codigo: { a: 'codigo' },
            valor_ven_novo: { a: 'valor_ven' },
            valor_for_novo: { a: 'valor_for' },
            obs: { a: 'obs' },
            id_cat: { j: { nome: { a: 'id_cat_nome' } } },
            nome: { a: 'nome' },
            status: { a: 'status' },
            cod_barra: { a: 'cod_barra' }
          } },
          qtde: null,
          valor_uni_novo: { a: 'valor_uni' },
          valor_tot_novo: { a: 'valor_tot' }
        }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
          // SETA OS DADOS RECEBIDOS
          this.compraItens = retorno.data
          
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA INICIAR A TABELA DE QUANTAS ETIQUETAS
          this.comEtiqTabelaQtdeIniciar()

          // CHAMA FUNÇÃO PARA FINALIZAR O CARREGAMENTO
          this.comEtiqFinalizarCarregamento()
        }, this.comEtiqSetarStatusGeral)

        // var self = this

        // // INICIA A BUSCA NA TELA DE COMPRA
        // var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, id_tipo: null, qtde: null, valor_tot: null }, where: { aAnd: [ { f: 'cod_op', o: '=', v: self.$store.state.gerarEtiqCompra }, { f: 'status', o: '=', v: '1' }, { f: 'tipo', o: '=', v: '2' } ] } }

        // self.$store.state.comunicaAPI('/compra/produto/get/', 'GET', queryGet, function (apiSuccess) {
        //   // SETA OS DADOS RECEBIDOS
        //   self.compraItens = apiSuccess.data

        //   var array = []
        //   for (var key in self.compraItens) {
        //     array.push(self.compraItens[key].id_tipo)
        //   }

        //   var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: { a: 'id_pro' }, codigo: null, cod_barra: null, valor_ven: null, obs: null, id_cat: { j: { nome: null } }, nome: { a: 'id_pro_nome' }, status: { a: 'id_pro_status' } }, where: { aAnd: [ { f: 'id', o: 'in', v: array.join() } ] } }

        //   self.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, function (apiSuccess) {
        //     for (var key in self.compraItens) {
        //       // ARREDONDA A QUANTIDADE
        //       self.compraItens[key].qtde = Math.ceil(Number(self.compraItens[key].qtde))

        //       // CALCULA O VALOR UNITARIO DO PRODUTO
        //       self.compraItens[key].valor_uni = self.$store.state.FUN_MASK_VALOR('valorMoeda', (self.compraItens[key].valor_tot / self.compraItens[key].qtde).toString())
              
        //       // FAZ UM MERGE DOS REGISTROS ENCONTRADOS
        //       self.compraItens[key] = Object.assign(self.compraItens[key], apiSuccess.data.filter(item => item.id_pro === self.compraItens[key].id_tipo)[0])

        //       // FORMATA O VALOR DE VENDA
        //       self.compraItens[key].valor_ven = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.compraItens[key].valor_ven)
        //     }

        //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //     self.time = new Date().getTime()

        //     // CHAMA A FUNÇÃO PARA INICIAR A TABELA DE QUANTAS ETIQUETAS
        //     self.comEtiqTabelaQtdeIniciar()

        //     // CHAMA FUNÇÃO PARA FINALIZAR O CARREGAMENTO
        //     self.comEtiqFinalizarCarregamento()
        //   }, self.comEtiqSetarStatusGeral)
        // }, self.comEtiqSetarStatusGeral)
      },
      comEtiqTabelaQtdeIniciar: function () {
        var self = this

        self.tabelaQtde = {
          status: '',
          montarTabelaCompleta: false,
          id: 'com-etiq-qtde',
          fraseTop: [ '<div class="com-etiq-qtde-titulo">Selecione a quantidade de etiquetas que deseja gerar para cada produto.</div>' ],
          coluna: [
            { mPer: 3, chave: 'codigo', nome: 'Cod.' },
            { mPer: 2, chave: 'nome_prod', nome: 'Nome', tipo: 'link-produto', converte: { id: 'id_pro', nome: 'nome', status: 'status' }, mostrarButton: true },
            { mPer: 3, chave: 'cod_barra', nome: 'Cód. Barras' },
            { mPer: 3, chave: 'obs', nome: 'Observação' },
            { mPer: 3, chave: '_valor_uni', nome: 'Custo' },
            { mPer: 3, chave: '_valor_ven', nome: 'Venda' },
            {
              mPer: 3,
              chave: 'rf-qtde',
              components: [
                'Quantidade',
                {
                  tipo: 'button',
                  tipoButton: 'texto',
                  id: self.tabelaQtde.id + '-rf-limpar-val',
                  status: '',
                  texto: 'Zerar',
                  class: 'btn btn-sm btn-default',
                  onClick: function () {
                    // ZERA TODOS OS CAMPOS
                    for (var key in self.tabelaQtde.linha) {
                      if (self.tabelaQtde.linha[key].hasOwnProperty('qtde')) {
                        self.tabelaQtde.linha[key]['rf-qtde'][0].value = '0'
                      }
                    }

                    // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                    self.time = new Date().getTime()

                    // APRESENTA A MENSAGEM
                    self.$store.state.msgWarn('WEB [200]: Todos os campos foram zerados.', 'success')
                  }
                }
              ]
            }
            // { mPer: 3, chave: 'valor_tot', nome: 'Valor Total', converte: { tipo: 'valorMoeda' } }
          ],
          acoes: {},
          linha: self.compraItens
        }

        for (var key in self.tabelaQtde.linha) {
          if (self.tabelaQtde.linha[key].hasOwnProperty('qtde')) {
            self.tabelaQtde.linha[key]['rf-qtde'] = [
              {
                tamanho: '55',
                tipo: 'input',
                type: 'number',
                value: self.tabelaQtde.linha[key].qtde,
                onChange: self.comEtiqTabelaOnChange
              }
            ]

            if (self.tabelaQtde.linha[key].cod_barra === '') {
              self.tabelaQtde.linha[key]['rf-qtde'][0].value = 0
              self.tabelaQtde.linha[key]['rf-qtde'][0].disabled = true
              self.tabelaQtde.linha[key]['rf-qtde'].push('<br/><span style="color: red">Sem código de barras</span>')
            }
          }

          var valorCusto = self.tabelaQtde.linha[key].valor_for

          while ((valorCusto.indexOf('.') > -1) || (valorCusto.indexOf(',') > -1)) {
            valorCusto = valorCusto.replace('.', '')
            valorCusto = valorCusto.replace(',', '')
          }
          valorCusto = Number(valorCusto)

          var valorVenda = self.tabelaQtde.linha[key].valor_ven
          while ((valorVenda.indexOf('.') > -1) || (valorVenda.indexOf(',') > -1)) {
            valorVenda = valorVenda.replace('.', '')
            valorVenda = valorVenda.replace(',', '')
          }
          valorVenda = Number(valorVenda)

          self.tabelaQtde.linha[key]._valor_ven = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', self.tabelaQtde.linha[key].valor_ven)
          if (valorVenda <= valorCusto) {
            self.tabelaQtde.linha[key]._valor_ven = '<b style="color: red;">' + this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', self.tabelaQtde.linha[key].valor_ven) + '</b>'
          }

          self.tabelaQtde.linha[key]._valor_uni = self.$store.state.FUN_MASK_VALOR('valorDecimalNovo', self.tabelaQtde.linha[key].valor_uni)

          // FORMATA A CATEGORIA DO PRODUTO COM 0 A ESQUERDA QUANDO NÃO FOR 2 DIGITOS
          self.tabelaQtde.linha[key].id_pro_id_cat = (self.tabelaQtde.linha[key].id_pro_id_cat.length <= 2 ? ('00' + self.tabelaQtde.linha[key].id_pro_id_cat).slice(-2) : self.tabelaQtde.linha[key].id_pro_id_cat)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabelaQtde, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabelaQtde = tabelaSuccess

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, self.comEtiqSetarStatusGeral)
      },
      comEtiqFinalizarCarregamento: function () {
        var self = this

        self.$store.state.FUN_CREATE_BUTTON_FORM('com-etiq', [ 0 ], null, {
          env: self.comEtiqGerarImpressao
          // rei: self.comEtiqTabelaConfigIniciar // CHAMA A FUNÇÃO PARA REINICIAR AS TABELAS
        }, function (buttons) {
          // SETA OS BUTTONS RECEBIDOS
          self.buttons = buttons

          // SETA O TEXTO DO BUTTON
          self.buttons.env.texto = 'Gerar Etiquetas'

          var options = []
          for (var i = 1; i <= self.config.cfg_n_colunas; i++) {
            options.push({ value: i.toString() })
          }

          self.iniciarEm = {
            tipo: 'select2',
            status: '',
            id: 'com-etiq-inicia-em',
            nome: '',
            keyValue: 'value',
            keyMostra: [ 'value' ],
            value: '1',
            options: options,
            optionInicialNome: '',
            optionInicialValue: '',
            onChange: function (value) {
              // SETA O VALOR RECEBIDO
              self.iniciarEm.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA O STATUS PARA TELA
          self.comEtiqSetarStatusGeral('')
        })
      },
      comEtiqTabelaConfigIniciar: function () {
        var self = this

        // CHAMA A FUNÇÃO PARA INICIAR AS TABELAS
        self.comEtiqTabelaConfig('geral')
        self.comEtiqTabelaConfig('fonte')
        self.comEtiqTabelaConfig('margem_interna')
        self.comEtiqTabelaConfig('margem_externa')

        self.$store.state.FUN_CREATE_BUTTON_FORM('com-etiq-config', [ 0 ], null, {
          env: self.comEtiqSalvarConfig
          // rei: self.comEtiqTabelaConfigIniciar // CHAMA A FUNÇÃO PARA REINICIAR AS TABELAS
        }, function (buttons) {
          // SETA OS BUTTONS RECEBIDOS
          self.buttonsConfig = buttons

          // SETA O TEXTO DO BUTTON
          self.buttonsConfig.env.texto = 'Salvar'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      comEtiqTabelaConfig: function (tipo) {
        var self = this

        var key = ''
        var chave = ''

        self.tabelaConfig[tipo] = {
          status: 'carregando',
          montarTabelaCompleta: false,
          id: 'com-etiq-config-' + tipo,
          fraseTop: [ ],
          coluna: []
        }

        switch (tipo) {
          case 'geral':
            self.tabelaConfig[tipo].fraseTop = [ '<div class="com-etiq-qtde-titulo">Configurações Gerais</div>' ]

            self.tabelaConfig[tipo].coluna = [
              // { mPer: 3, chave: 'lin', nome: 'Nº Linha', apiEnv: 'cfg_n_linhas' },
              { mPer: 3, chave: 'col', nome: 'Nº Coluna', apiEnv: 'cfg_n_colunas' },
              { mPer: 3, chave: 'cel', nome: 'Tam. Célula', apiEnv: 'cfg_tam_celula' },
              { mPer: 3, chave: 'tam', nome: 'Tam. Cód. Barra', apiEnv: 'cfg_tam_cod_barra' },
              { mPer: 3, chave: 'mos', nome: 'Exibir Borda', apiEnv: 'cfg_borda_etiq' },
            ]

            self.tabelaConfig[tipo].linha = [
              {
                col: [
                  {
                    tamanho: '55',
                    tipo: 'input',
                    type: 'number',
                    value: self.config.cfg_n_colunas,
                    onChange: self.comEtiqTabelaOnChange
                  }
                ],
                cel: [
                  {
                    tamanho: '55',
                    tipo: 'input',
                    type: 'number',
                    value: self.config.cfg_tam_celula,
                    onChange: self.comEtiqTabelaOnChange
                  },
                  ' px'
                ],
                tam: [
                  {
                    tamanho: '55',
                    tipo: 'input',
                    type: 'number',
                    value: self.config.cfg_tam_cod_barra,
                    onChange: self.comEtiqTabelaOnChange
                  },
                  ' px'
                ],
                mos: [
                  {
                    tamanho: '55',
                    tipo: 'select2',
                    type: 'number',
                    options: [
                      { id: '0', value: 'Não' },
                      { id: '1', value: 'Sim' }
                    ],
                    optionInicialNome: '',
                    keyValue: 'id',
                    keyMostra: [ 'value' ],
                    value: self.config.cfg_borda_etiq,
                    onChange: self.comEtiqTabelaOnChange
                  }
                ]
              }
            ]
            break

          default:
            switch (tipo) {
              case 'fonte':
                self.tabelaConfig[tipo].fraseTop = [ '<div class="com-etiq-qtde-titulo">Configurações do tamanho da fonte e espaçamento</div>' ]

                self.tabelaConfig[tipo].coluna = [
                  { mPer: 3, chave: 'lin', nome: 'Tam. Nome', apiRec: 'cfg_tam_font_nome', apiEnv: 'cfg_tam_font_nome' },
                  { mPer: 3, chave: 'col', nome: 'Tam. Valor', apiRec: 'cfg_tam_font_valor', apiEnv: 'cfg_tam_font_valor' },
                  { mPer: 3, chave: 'cel', nome: 'Tam. Cód. Barras', apiRec: 'cfg_tam_font_cod', apiEnv: 'cfg_tam_font_cod' },
                  { mPer: 3, chave: 'tam', nome: 'Espaço letras Cod. Barras', apiRec: 'cfg_tam_esp_letra', apiEnv: 'cfg_tam_esp_letra' }
                ]
                break

              case 'margem_externa':
                self.tabelaConfig[tipo].fraseTop = [ '<div class="com-etiq-qtde-titulo">Configurações do tamanho da margem externa da célula</div>' ]

                self.tabelaConfig[tipo].coluna = [
                  { mPer: 3, chave: 'mar_top', nome: 'Margem Superior', apiRec: 'cfg_f_mar_top', apiEnv: 'cfg_f_mar_top' },
                  { mPer: 3, chave: 'mar_right', nome: 'Margem Direita', apiRec: 'cfg_f_mar_right', apiEnv: 'cfg_f_mar_right' },
                  { mPer: 3, chave: 'mar_bottom', nome: 'Margem Inferior', apiRec: 'cfg_f_mar_button', apiEnv: 'cfg_f_mar_button' },
                  { mPer: 3, chave: 'mar_left', nome: 'Margem Esquerda', apiRec: 'cfg_f_mar_left', apiEnv: 'cfg_f_mar_left' }
                ]
                break

              case 'margem_interna':
                self.tabelaConfig[tipo].fraseTop = [ '<div class="com-etiq-qtde-titulo">Configurações do tamanho da margem interna da célula</div>' ]

                self.tabelaConfig[tipo].coluna = [
                  { mPer: 3, chave: 'mar_top', nome: 'Margem Superior', apiRec: 'cfg_d_mar_top', apiEnv: 'cfg_d_mar_top' },
                  { mPer: 3, chave: 'mar_right', nome: 'Margem Direita', apiRec: 'cfg_d_mar_right', apiEnv: 'cfg_d_mar_right' },
                  { mPer: 3, chave: 'mar_bottom', nome: 'Margem Inferior', apiRec: 'cfg_d_mar_button', apiEnv: 'cfg_d_mar_button' },
                  { mPer: 3, chave: 'mar_left', nome: 'Margem Esquerda', apiRec: 'cfg_d_mar_left', apiEnv: 'cfg_d_mar_left' }
                ]
                break
            }

            self.tabelaConfig[tipo].linha = [ {} ]
            for (key in self.tabelaConfig[tipo].coluna) {
              chave = self.tabelaConfig[tipo].coluna[key].chave
              self.tabelaConfig[tipo].linha[0][chave] = [
                {
                  tamanho: '55',
                  tipo: 'input',
                  type: 'number',
                  value: self.config[self.tabelaConfig[tipo].coluna[key].apiRec],
                  onChange: self.comEtiqTabelaOnChange
                },
                ' px'
              ]
            }
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabelaConfig[tipo], function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabelaConfig[tipo] = tabelaSuccess

          // SETA O STATUS DA TABELA
          self.tabelaConfig[tipo].status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, self.comEtiqSetarStatusGeral)
      },
      comEtiqTabelaOnChange: function (value, id) {
        var index = id.split('--')
        var tabela = {}

        switch (index[0]) {
          case 'com-etiq-qtde':
            tabela = this.tabelaQtde
            break

          case 'com-etiq-config-geral':
            tabela = this.tabelaConfig.geral
            break

          case 'com-etiq-config-fonte':
            tabela = this.tabelaConfig.fonte
            break

          case 'com-etiq-config-margem_interna':
            tabela = this.tabelaConfig.margem_interna
            break
          
          case 'com-etiq-config-margem_externa':
            tabela = this.tabelaConfig.margem_externa
            break
        }

        // SETA O VALOR RECEBIDO
        tabela.linha[index[1]][index[2]][index[3]].value = value

        // REMOVE A MENSAGEM DE ERRO
        tabela.linha[index[1]][index[2]][index[3]].mensagem = ''
        tabela.linha[index[1]][index[2]][index[3]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      comEtiqSetarStatusGeral: function (status) {
        // SETA O STATUS PARA TELA
        this.statusGeral = status

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      comEtiqSalvarConfig: function () {
        var formData = {}

        for (var tab in this.tabelaConfig) {
          // PEGA QUAIS COLUNAS DEVEM SER ENVIADAS PARA API
          var coluna = this.tabelaConfig[tab].coluna.filter(item => item.hasOwnProperty('apiEnv'))

          // PEGA O VALOR DE CADA COLUNA
          for (var col in coluna) {
            formData[coluna[col].apiEnv] = this.tabelaConfig[tab].linha[0][coluna[col].chave][0].value
          }
        }
      },
      comEtiqFechar: function () {
        this.$store.commit('SET_GERAR_ETIQUETA_COMPRA', '')
      },
      comEtiqGerarImpressao: function () {
        if (this.gerarImpressao !== null) {
          // FECHA A JANELA
          this.gerarImpressao = null

          // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          var self = this

          self.comEtiqBucarConfiguracoes(function () {
            // SETA O BOTÃO DE IMPRESSÃO
            self.buttonImprimir = {
              id: 'etiq-bt-imprimir',
              status: '',
              texto: 'Imprimir',
              statusImprimir: false,
              class: [ 'btn', 'btn-default', 'btn-sm' ],
              onClick: function () {
                // SETA O STATUS DO BOTÃO IMPRIMIR
                self.buttonImprimir.statusImprimir = true

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                setTimeout(function () {
                  // CHAMADA DO PLUGIN PARA IMPRIMIR CONTEUDO DA DIV
                  $('#rf-dialog-etiq-imprmir').printElement({ etiqueta: true })

                  // SETA O STATUS DO BOTÃO IMPRIMIR
                  self.buttonImprimir.statusImprimir = false

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
                }, 300)
              }
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // INICIA O PLUGIN MOMENT PARA CALCULAR A DATA
            var moment = require('moment')
    
            // INICIA AS VARIAVEIS
            var qtde = 0
            var linha = 0
            var coluna = 0
            var etiquetas = {}
            var custo = ''

            if (self.iniciarEm.value !== '1') {
              for (coluna = 0; coluna < Number(self.iniciarEm.value); coluna++) {
                // VERIFICA SE A LINHA JÁ FOI INICIADA
                if (!etiquetas.hasOwnProperty(linha)) {
                  etiquetas[linha] = {}
                }
  
                // VERIFICA SE A COLUNA JÁ FOI INICIADA
                if (!etiquetas.hasOwnProperty(coluna)) {
                  etiquetas[linha][coluna] = 'vazio'
                }
              }
            }
    
            for (var key in self.tabelaQtde.linha) {
              if (self.tabelaQtde.linha[key].hasOwnProperty('rf-qtde')) {
                // VERIFICA QUANTAS ETIQUETAS É PARA FAZER DESTE PRODUTO
                qtde = Number(self.tabelaQtde.linha[key]['rf-qtde'][0].value)
    
                // SETA OS DADOS COMPLEMENTARES DA LINHA
                self.tabelaQtde.linha[key].data = moment(self.compraDados.data_ptbr, 'DD/MM/YYYY').format('MMYY')
    
                // CALCULA O CUSTO DA MERCADORIA E CRIPTOGRAFA
                // custo = Math.ceil((self.tabelaQtde.linha[key].valor_tot / self.tabelaQtde.linha[key].qtde) / 100).toString()
                custo = Math.ceil(Number(self.tabelaQtde.linha[key].valor_uni).toString()).toString()
                if (custo.length === 4) {
                  custo = (custo.length <= 4 ? ('0000' + custo).slice(-4) : self.tabelaQtde.linha[key].custo).split('')
                  self.tabelaQtde.linha[key].custo = self.custoCryto[custo[0]] + self.custoCryto[custo[1]] + self.custoCryto[custo[2]] + self.custoCryto[custo[3]]
                } else {
                  custo = (custo.length <= 3 ? ('000' + custo).slice(-3) : self.tabelaQtde.linha[key].custo).split('')
                  self.tabelaQtde.linha[key].custo = self.custoCryto[custo[0]] + self.custoCryto[custo[1]] + self.custoCryto[custo[2]]
                }
    
                for (var i = 1; i <= qtde; i++) {
                  if (Object.keys(etiquetas).length >= 1 && Object.keys(etiquetas[linha]).length >= Number(self.config.cfg_n_colunas)) {
                    // INICIA UMA NOVA LINHA
                    linha++
                    coluna = 0
                  }
    
                  // VERIFICA SE A LINHA JÁ FOI INICIADA
                  if (!etiquetas.hasOwnProperty(linha)) {
                    etiquetas[linha] = {}
                  }
    
                  // VERIFICA SE A COLUNA JÁ FOI INICIADA
                  if (!etiquetas.hasOwnProperty(coluna)) {
                    etiquetas[linha][coluna] = {}
                  }
    
                  // ADICIONA A ETIQUETA QUANTAS VEZES FOI SOLICITADO
                  etiquetas[linha][coluna] = self.tabelaQtde.linha[key]
    
                  // CALCULA O NUMERO DA COLUNA
                  coluna++
                }
              }
            }
    
            // SETA AS ETIQUETAS GERADAS
            self.gerarImpressao = etiquetas
    
            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()

            setTimeout(function() {
              // CRIA OS CODIGOS DE BARRAS NA TELA
              var JsBarcode = require('jsbarcode')
              JsBarcode(".barcode").init()

              setTimeout(function() {
                for (var key in self.$refs['svg']) {
                  self.$refs['svg'][key].style.width = (self.config.cfg_tam_celula - 12) + 'px'
                  self.$refs['svg'][key].style.height = Number(self.config.cfg_tam_cod_barra) - 10
                }
              }, 500)
            }, 500)
          })
        }
      }
    },
    watch: {
      mostrarConfig: function () {
        switch (this.mostrarConfig) {
          case true:
            if (Object.keys(this.tabelaConfig).length === 0) {
              // CHAMA A FUNÇÃO PARA INICIAR AS TABELAS
              this.comEtiqTabelaConfigIniciar()
            }
            break
        }
      }
    }
  }
</script>
